import React, { FunctionComponent, ReactNode, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// MaterialUi components
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import AddIcon from '@mui/icons-material/Add';

// Components
import Separator from '../../../Separator/Separator';

// types and constants
import { UserModel } from '../../../../shared/types';
import { USER_TABLE_COLUMNS } from '../../../../shared/constants';

type UserTableProps = {
    isLoading: boolean;
    users: UserModel[];
}

const UsersTable: FunctionComponent<UserTableProps> = (props: UserTableProps) => {
    const { isLoading, users } = props;

    const navigate = useNavigate();

    const goTo = (route: string) => {
        navigate(route);
    }

    return (
        <div data-testid='user-table-container' className='align-center user-table-container bottom-padding'>
            <Button
                data-testid='assign-role-btn'
                variant='outlined'
                onClick={() => goTo(`/users/assignRole`)}
                startIcon={<AddIcon />}
            >
                Assign Role
            </Button>

            <Separator />
            <Separator />

            <DataGrid
                sx={{ border: 'none' }}
                rows={users}
                columns={USER_TABLE_COLUMNS}
                density='comfortable'
                hideFooterSelectedRowCount
                autoHeight
                components={{
                    LoadingOverlay: LinearProgress,
                }}
                loading={isLoading}
                autoPageSize
                pageSize={10}
            // rowsPerPageOptions={[5]}
            // checkboxSelection
            // onSelectionModelChange={sellectionHandler}
            />
        </div>
    )
}

export default UsersTable;